import { InjectionToken, Inject, Injectable, Optional, Component, Host, Input, Output, EventEmitter, Injector, NgModule, APP_INITIALIZER } from '@angular/core';
import { __spread, __values, __extends } from 'tslib';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
AvailabilityService = /** @class */ (function () {
    function AvailabilityService() {
    }
    return AvailabilityService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
ResizeService = /** @class */ (function () {
    function ResizeService() {
    }
    return ResizeService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var TK3D_HANDLERS = new InjectionToken('tk3d handlers');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var TK3D_CONFIG = new InjectionToken('TK3D configuration');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/*little wrapper around tk3d*/
var Tk3dService = /** @class */ (function () {
    function Tk3dService(handlers, config, resizeService) {
        this.handlers = handlers;
        this.config = config;
        this.resizeService = resizeService;
        this.initialStatus = {
            blockmap: { size: 'large', moduleRef: undefined, selected: undefined, visible: true, showLoader: false },
            seatmap: { size: 'large', moduleRef: undefined, selected: [], visible: false, showLoader: false },
            view3d: { size: 'large', moduleRef: undefined, selected: undefined, visible: false, showLoader: false },
        };
        this.tk3d = new TICKETING3D(this.config.venue);
        this.reset();
    }
    Object.defineProperty(Tk3dService.prototype, "tk3dStatus", {
        get: /**
         * @return {?}
         */
        function () {
            return this.status;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} alsoModules
     * @return {?}
     */
    Tk3dService.prototype.reset = /**
     * @param {?=} alsoModules
     * @return {?}
     */
    function (alsoModules) {
        if (alsoModules === void 0) { alsoModules = false; }
        if (typeof this.status === 'undefined') {
            this.status = JSON.parse(JSON.stringify(this.initialStatus));
        }
        else {
            // tslint:disable-next-line:forin
            for (var module in this.status) {
                for (var key in this.status[module]) {
                    if (!alsoModules && key === 'moduleRef') {
                        continue;
                    }
                    this.status[module][key] = this.initialStatus[module][key];
                }
            }
        }
        if (this.resizeService) {
            this.tk3dStatus.resizeForce = false;
            requestAnimationFrame(this.onWindowChange.bind(this));
        }
    };
    /**
     * @param {?} name
     * @param {...?} args
     * @return {?}
     */
    Tk3dService.prototype.action = /**
     * @param {?} name
     * @param {...?} args
     * @return {?}
     */
    function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        return (_a = this.tk3d)[name].apply(_a, __spread(args));
    };
    /**
     * @param {?} config
     * @param {?} module
     * @return {?}
     */
    Tk3dService.prototype.loadModule = /**
     * @param {?} config
     * @param {?} module
     * @return {?}
     */
    function (config, module) {
        if (!this.tk3d) {
            alert('initialize tk3d with venue id');
            return;
        }
        return this.status[module].moduleRef = this.tk3d['loadModule'](config);
    };
    /**
     * @return {?}
     */
    Tk3dService.prototype.onSeatMapMiniClick = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var message = {
            emitter: 'seatmap',
            event: 'click',
            emmitterSize: 'mini',
        };
        this.handle(message);
    };
    /**
     * @return {?}
     */
    Tk3dService.prototype.onBlockMapMiniClick = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var message = {
            emitter: 'blockmap',
            event: 'click',
            emmitterSize: 'mini',
        };
        this.handle(message);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    Tk3dService.prototype.onMapAvailabilityLoaded = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        /** @type {?} */
        var message = {
            emitter: type,
            event: 'availabilityloaded',
            emmitterSize: 'large',
        };
        this.handle(message);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Tk3dService.prototype.handle = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var e_1, _a;
        try {
            for (var _b = __values(this.handlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler = _c.value;
                if (handler.canHandle({ type: message.emitter, event: message.event })) {
                    handler.handle(message, this.status);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    Tk3dService.prototype.getSectorRowSeat = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var sector;
        /** @type {?} */
        var row;
        /** @type {?} */
        var seat;
        sector = id.split('_')[1].split('-')[0];
        try {
            row = id.split('_')[1].split('-')[1];
            seat = id.split('_')[1].split('-')[2];
        }
        catch (e) {
            row = '';
            seat = '';
        }
        return {
            sector: sector,
            row: row,
            seat: seat,
        };
    };
    /**
     * @return {?}
     */
    Tk3dService.prototype.onWindowChange = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var neww = window.innerWidth;
        /** @type {?} */
        var newh = window.innerHeight;
        if (this.oldw !== neww || this.oldh !== newh || this.tk3dStatus.resizeForce === true) {
            this.oldw = neww;
            this.oldh = newh;
            if (this.tk3dStatus.resizeForce) {
                this.tk3dStatus.resizeForce = false;
            }
            this.resizeService.handleResize(this.tk3dStatus);
        }
        requestAnimationFrame(this.onWindowChange.bind(this));
    };
    /**
     * @param {?} venueId
     * @param {?=} resizeForce
     * @return {?}
     */
    Tk3dService.prototype.changeVenue = /**
     * @param {?} venueId
     * @param {?=} resizeForce
     * @return {?}
     */
    function (venueId, resizeForce) {
        var _this = this;
        if (resizeForce === void 0) { resizeForce = true; }
        this.config.resetModules = false;
        this.config.venue = venueId;
        this.tk3d['changeVenue'](venueId);
        this.reset();
        setTimeout(function () {
            _this.config.resetModules = true;
            _this.status.resizeForce = resizeForce;
        }, 300);
        setTimeout(function () {
            _this.config.resetModules = false;
        }, 600);
    };
    Tk3dService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    Tk3dService.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: Inject, args: [TK3D_HANDLERS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] },
        { type: ResizeService, decorators: [{ type: Optional }] }
    ]; };
    return Tk3dService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var mouseEvents = [
    'click', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseout', 'mouseover', 'mouseup'
];
/** @type {?} */
var selectionEvents = ['elementselected', 'elementunselected'];
/** @type {?} */
var loadedEvents = ['loaded'];
/** @type {?} */
var emptyArray = [];
/** @type {?} */
var mapModuleEvents = emptyArray.concat(mouseEvents, selectionEvents, loadedEvents);
// const allMapModuleEvents = mapModuleEvents.concat('general');
/** @type {?} */
var ALL_MAP_EVENTS = new InjectionToken('mouse events helper');
/** @type {?} */
var AllMapEventsArrayHelperProvider = { provide: ALL_MAP_EVENTS, useValue: mapModuleEvents };

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var BasicModuleService = /** @class */ (function () {
    function BasicModuleService(tk3d) {
        this.tk3d = tk3d;
        this.callbacks = {};
        this.emitters = {};
    }
    /**
     * @param {?} event
     * @return {?}
     */
    BasicModuleService.prototype.constructCallbackBinded = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var boundFunction = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this.handleCallback.apply(// parenthesis are not necessary
            this, __spread(args));
        }).bind(this, event);
        return boundFunction;
    };
    /**
     * @param {?} size
     * @return {?}
     */
    BasicModuleService.prototype.changeContainer = /**
     * @param {?} size
     * @return {?}
     */
    function (size) {
        /** @type {?} */
        var selector = size === 'large' ? this.selector : this.miniSelector;
        try {
            this.moduleRef.setContainer(selector);
            this.size = size;
        }
        catch (err) {
            console.log(err);
        }
    };
    /**
     * @param {?} event
     * @param {?} extra
     * @return {?}
     */
    BasicModuleService.prototype.handleCallback = /**
     * @param {?} event
     * @param {?} extra
     * @return {?}
     */
    function (event, extra) {
        /** @type {?} */
        var message = this.constructMessage(event, extra);
        this.tk3d.handle(message);
        this.emitters['tk3dgeneral'].emit(message);
        /*this.emitters[event].emit(message);
        this.emitters['general'].emit(message);*/
    };
    /**
     * @return {?}
     */
    BasicModuleService.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.moduleRef['destroy']();
    };
    BasicModuleService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BasicModuleService.ctorParameters = function () { return [
        { type: Tk3dService }
    ]; };
    return BasicModuleService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Tk3dMapService = /** @class */ (function (_super) {
    __extends(Tk3dMapService, _super);
    function Tk3dMapService(tk3d, mouseEventsCallbacks, config) {
        var e_1, _a;
        var _this = _super.call(this, tk3d) || this;
        _this.mouseEventsCallbacks = mouseEventsCallbacks;
        _this.config = config;
        _this.defaultPlugins = ['SelectionPlugin', 'ZoomButtonsPlugin'];
        _this.defaultFlags = {
            multiple_selection: true,
            keep_selections: false,
            user_selection: false,
            available_by_default: false,
            max_selection: 1
        };
        try {
            for (var _b = __values(_this.mouseEventsCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mouseEventCallback = _c.value;
                _this.callbacks[mouseEventCallback] = _this.constructCallbackBinded(mouseEventCallback);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    /**
     * @return {?}
     */
    Tk3dMapService.prototype.configurator = /**
     * @return {?}
     */
    function () {
        var e_2, _a;
        if (this.config.flags && this.config.flags[this.mapModuleType]) {
            try {
                for (var _b = __values(Object.keys(this.config.flags[this.mapModuleType])), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var flag = _c.value;
                    this.defaultFlags[flag] = this.config.flags[this.mapModuleType][flag];
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (this.config.defaultPlugins) {
            this.defaultPlugins = this.config.defaultPlugins;
            if (this.defaultPlugins.indexOf('SelectionPlugin') === -1) {
                this.defaultPlugins.push('SelectionPlugin');
            }
        }
    };
    /**
     * @param {?} emmitters
     * @param {?} mapType
     * @return {?}
     */
    Tk3dMapService.prototype.init = /**
     * @param {?} emmitters
     * @param {?} mapType
     * @return {?}
     */
    function (emmitters, mapType) {
        this.emitters = emmitters;
        this.mapModuleType = mapType;
        this.configurator();
        this.selector = this.mapModuleType;
        this.miniSelector = this.mapModuleType + '-mini';
        this.size = 'large';
        this.blockSelected = undefined;
        /** @type {?} */
        var seatBlock = mapType === 'blockmap' ? 'block' : 'seat';
        /** @type {?} */
        var callbacks = {};
        callbacks[seatBlock] = this.callbacks;
        /** @type {?} */
        var selection = {};
        selection[seatBlock] = {};
        selection[seatBlock]['flags'] = this.defaultFlags;
        /** @type {?} */
        var config = {
            module: 'map',
            container: mapType,
            plugins: this.defaultPlugins,
            config: {
                callbacks: callbacks,
                selection: selection,
            }
        };
        if (this.config.neighborsInfo) {
            config.config['NeighborsPlugin'] = {};
            config.config['NeighborsPlugin']['neighbors'] = this.config.neighborsInfo;
            config.config['callbacks']['neighbors'] = {};
            config.config['callbacks']['neighbors']['clickNeighbor'] = this.constructCallbackBinded('clickNeighbor');
        }
        this.moduleRef = this.tk3d.loadModule(config, this.mapModuleType);
        window[mapType] = this.moduleRef;
    };
    /**
     * @param {?} blockID
     * @return {?}
     */
    Tk3dMapService.prototype.loadElement = /**
     * @param {?} blockID
     * @return {?}
     */
    function (blockID) {
        this.blockSelected = blockID;
        this.moduleRef.loadMap(blockID, this.callbacks['loaded']);
    };
    /**
     * @return {?}
     */
    Tk3dMapService.prototype.onLoad = /**
     * @return {?}
     */
    function () {
        // console.log('load');
    };
    /*changeContainer(size: ModuleSize) {
      const selector = size === 'large' ? this.type :  this.miniSelector;
      try {
        this.mapModule.setContainer(selector);
        this.size = size;
      } catch (err) {
        console.log(err);
      }
    }*/
    /*changeContainer(size: ModuleSize) {
        const selector = size === 'large' ? this.type :  this.miniSelector;
        try {
          this.mapModule.setContainer(selector);
          this.size = size;
        } catch (err) {
          console.log(err);
        }
      }*/
    /**
     * @param {?} event
     * @param {?} elementClicked
     * @return {?}
     */
    Tk3dMapService.prototype.constructMessage = /*changeContainer(size: ModuleSize) {
        const selector = size === 'large' ? this.type :  this.miniSelector;
        try {
          this.mapModule.setContainer(selector);
          this.size = size;
        } catch (err) {
          console.log(err);
        }
      }*/
    /**
     * @param {?} event
     * @param {?} elementClicked
     * @return {?}
     */
    function (event, elementClicked) {
        /** @type {?} */
        var message = {
            event: event,
            emitter: this.mapModuleType,
            emmitterSize: this.size,
            element: (/** @type {?} */ (elementClicked))
        };
        return message;
    };
    /**
     * @param {?} show
     * @return {?}
     */
    Tk3dMapService.prototype.toggleVisibility = /**
     * @param {?} show
     * @return {?}
     */
    function (show) {
        /** @type {?} */
        var action = show ? 'show' : 'hide';
        this.moduleRef[action]();
    };
    Tk3dMapService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    Tk3dMapService.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: undefined, decorators: [{ type: Inject, args: [ALL_MAP_EVENTS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return Tk3dMapService;
}(BasicModuleService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Basic map component
 */
var MapComponent = /** @class */ (function () {
    function MapComponent(tk3d, mapService, allMapEvents) {
        this.tk3d = tk3d;
        this.mapService = mapService;
        this.allMapEvents = allMapEvents;
        /**
         * All events are emmited with this event emitter
         */
        this.tk3dgeneral = new EventEmitter();
        /*@Output() tk3dclick = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dloaded = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmousedown = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmouseenter = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmouseleave = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmousemove = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmouseout = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmouseover = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dmouseup = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dgeneral = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3delementselected = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3delementunselected = new EventEmitter<InteractionMessageProtocol>();*/
        this.emitters = {};
        this.emitters['tk3dgeneral'] = this.tk3dgeneral;
        /*const allEvents = allMapEvents.concat('general');
        for (const eventCallback of allEvents) {
          this.emitters[eventCallback] = this['tk3d' + eventCallback];
        }
        console.log(this.emitters);*/
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MapComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes['type']) {
            this.mapService.init(this.emitters, this.type);
        }
        if (changes['mapId'] && changes['mapId'].currentValue) {
            this.mapService.loadElement(changes['mapId'].currentValue);
        }
        if (changes['size'] && changes['size'].currentValue && !changes['size'].firstChange) {
            this.mapService.changeContainer(changes['size'].currentValue);
        }
        if (changes['visible'] && !changes['visible'].firstChange) {
            this.mapService.toggleVisibility(changes['visible'].currentValue);
        }
        if (changes['reset'] && changes['reset'].currentValue) {
            this.mapService.destroy();
            this.mapService.init(this.emitters, this.type);
            if (this.mapId) {
                this.mapService.loadElement(this.mapId);
            }
        }
        if (changes['showLoader']) {
            this.loaderHidden = !this.showLoader;
        }
    };
    MapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-map-module',
                    template: "<ng-content select=\"[name=internal-pre]\"></ng-content>\n<div id={{type}}>\n  <div [hidden]=\"loaderHidden\" id=\"{{type}}-loader\"></div>\n</div>\n<ng-content select=\"[name=internal-after]\"></ng-content>\n",
                    providers: [Tk3dMapService],
                    styles: ["#blockmap,#seatmap{position:relative}#blockmap-loader,#seatmap-loader{position:absolute;top:0;bottom:0;left:0;right:0;background-color:#d3d3d3;z-index:1}"]
                }] }
    ];
    /** @nocollapse */
    MapComponent.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: Tk3dMapService, decorators: [{ type: Host }] },
        { type: undefined, decorators: [{ type: Inject, args: [ALL_MAP_EVENTS,] }] }
    ]; };
    MapComponent.propDecorators = {
        type: [{ type: Input }],
        size: [{ type: Input }],
        mapId: [{ type: Input }],
        plugins: [{ type: Input }],
        visible: [{ type: Input }],
        showLoader: [{ type: Input }],
        reset: [{ type: Input }],
        selection_flags: [{ type: Input }],
        extraPluginConfig: [{ type: Input }],
        tk3dgeneral: [{ type: Output }]
    };
    return MapComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var allEvents = ['fullscreen', 'userevent', 'contextready', 'loaded'];
/** @type {?} */
var ALL_VIEW3D_EVENTS = new InjectionToken('view3d events helper');
/** @type {?} */
var AllView3dEventsArrayHelperProvider = { provide: ALL_VIEW3D_EVENTS, useValue: allEvents };

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var View3dService = /** @class */ (function (_super) {
    __extends(View3dService, _super);
    function View3dService(tk3d, events, config) {
        var e_1, _a;
        var _this = _super.call(this, tk3d) || this;
        _this.events = events;
        _this.config = config;
        try {
            for (var _b = __values(_this.events), _c = _b.next(); !_c.done; _c = _b.next()) {
                var event_1 = _c.value;
                _this.callbacks[event_1] = _this.constructCallbackBinded(event_1);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this.selector = 'view3d';
        _this.miniSelector = _this.selector + '-mini';
        return _this;
    }
    /**
     * @param {?} emitters
     * @return {?}
     */
    View3dService.prototype.init = /**
     * @param {?} emitters
     * @return {?}
     */
    function (emitters) {
        this.emitters = emitters;
        /** @type {?} */
        var config = {
            module: 'view3d',
            container: this.selector,
            config: {
                callbacks: this.callbacks
            }
        };
        if (this.config.defaultPlugins.indexOf('NavigationPlugin')) {
            config['plugins'] = ['NavigationPlugin'];
        }
        this.moduleRef = this.tk3d.loadModule(config, 'view3d');
        window['view3d'] = this.moduleRef;
    };
    /**
     * @param {?} panoID
     * @return {?}
     */
    View3dService.prototype.loadElement = /**
     * @param {?} panoID
     * @return {?}
     */
    function (panoID) {
        this.panoSelected = panoID;
        this.moduleRef.load(panoID, this.callbacks['loaded']);
    };
    /**
     * @param {?} event
     * @param {?} extra
     * @return {?}
     */
    View3dService.prototype.constructMessage = /**
     * @param {?} event
     * @param {?} extra
     * @return {?}
     */
    function (event, extra) {
        /** @type {?} */
        var message = {
            event: event,
            emitter: 'view3d',
            emmitterSize: this.size,
            elementSelected: this.panoSelected,
        };
        return message;
    };
    View3dService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    View3dService.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: undefined, decorators: [{ type: Inject, args: [ALL_VIEW3D_EVENTS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return View3dService;
}(BasicModuleService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var View3dComponent = /** @class */ (function () {
    function View3dComponent(tk3d, v3dService, allMapEvents) {
        this.tk3d = tk3d;
        this.v3dService = v3dService;
        this.allMapEvents = allMapEvents;
        /**
         * All events are emmited with this event emitter
         */
        this.tk3dgeneral = new EventEmitter();
        /*@Output() tk3dfullscreen = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dloaded = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3duserevent = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dcontextready = new EventEmitter<InteractionMessageProtocol>();
          @Output() tk3dgeneral = new EventEmitter<InteractionMessageProtocol>();*/
        this.emitters = {};
        this.emitters['tk3dgeneral'] = this.tk3dgeneral;
        this.v3dService.init(this.emitters);
        /*const allEvents = allMapEvents.concat('general');
        for (const eventCallback of allEvents) {
          this.emitters[eventCallback] = this['tk3d' + eventCallback];
        }
        console.log(this.emitters);*/
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    View3dComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes['panoID'] && changes['panoID'].currentValue) {
            this.v3dService.loadElement(changes['panoID'].currentValue);
        }
        if (changes['size'] && changes['size'].currentValue && !changes['size'].firstChange) {
            this.v3dService.changeContainer(changes['size'].currentValue);
        }
        if (changes['showLoader']) {
            this.loaderHidden = !this.showLoader;
        }
        if (changes['reset'] && changes['reset'].currentValue) {
            this.v3dService.destroy();
            this.v3dService.init(this.emitters);
            if (this.panoID) {
                this.v3dService.loadElement(this.panoID);
            }
        }
    };
    View3dComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-view3d',
                    template: "<div id=\"view3d\">\n  <div [hidden]=\"loaderHidden\" id=\"view3d-loader\"></div>\n</div>\n",
                    providers: [View3dService],
                    styles: ["#view3d{position:relative}#view3d-loader{position:absolute;top:0;bottom:0;left:0;right:0;background-color:#d3d3d3;z-index:11}"]
                }] }
    ];
    /** @nocollapse */
    View3dComponent.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: View3dService, decorators: [{ type: Host }] },
        { type: undefined, decorators: [{ type: Inject, args: [ALL_VIEW3D_EVENTS,] }] }
    ]; };
    View3dComponent.propDecorators = {
        panoID: [{ type: Input }],
        size: [{ type: Input }],
        showLoader: [{ type: Input }],
        reset: [{ type: Input }],
        tk3dgeneral: [{ type: Output }]
    };
    return View3dComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockmapBindedComponent = /** @class */ (function () {
    function BlockmapBindedComponent(tk3d, config) {
        this.tk3d = tk3d;
        this.config = config;
    }
    Object.defineProperty(BlockmapBindedComponent.prototype, "blockmapSize", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.blockmap.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockmapBindedComponent.prototype, "mapId", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.mapId ? this.config.mapId : 'blockmap';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockmapBindedComponent.prototype, "blockmapVisibility", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.blockmap.visible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockmapBindedComponent.prototype, "showLoader", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.blockmap.showLoader;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockmapBindedComponent.prototype, "resetModules", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.resetModules;
        },
        enumerable: true,
        configurable: true
    });
    BlockmapBindedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-blockmap-binded',
                    template: "<tk3d-map-module\n  [type]=\"'blockmap'\" [mapId]=\"mapId\" [size]=\"blockmapSize\" [visible]=\"blockmapVisibility\" [showLoader]=\"showLoader\"\n  [reset]=\"resetModules\">\n</tk3d-map-module>\n\n"
                }] }
    ];
    /** @nocollapse */
    BlockmapBindedComponent.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return BlockmapBindedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatmapBindedComponent = /** @class */ (function () {
    function SeatmapBindedComponent(tk3d, config) {
        this.tk3d = tk3d;
        this.config = config;
    }
    Object.defineProperty(SeatmapBindedComponent.prototype, "blockSelected", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.blockmap.selected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeatmapBindedComponent.prototype, "seatmapSize", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.seatmap.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeatmapBindedComponent.prototype, "seatmapVisibility", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.seatmap.visible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeatmapBindedComponent.prototype, "showLoader", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.seatmap.showLoader;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeatmapBindedComponent.prototype, "resetModules", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.resetModules;
        },
        enumerable: true,
        configurable: true
    });
    SeatmapBindedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-seatmap-binded',
                    template: "<tk3d-map-module\n  [type]=\"'seatmap'\" [mapId]=\"blockSelected\" [size]=\"seatmapSize\" [visible]=\"seatmapVisibility\"\n  [showLoader]=\"showLoader\" [reset]=\"resetModules\">\n</tk3d-map-module>\n\n"
                }] }
    ];
    /** @nocollapse */
    SeatmapBindedComponent.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return SeatmapBindedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var View3dBindedComponent = /** @class */ (function () {
    function View3dBindedComponent(tk3d, config) {
        this.tk3d = tk3d;
        this.config = config;
    }
    Object.defineProperty(View3dBindedComponent.prototype, "panoSelected", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.view3d.selected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View3dBindedComponent.prototype, "size", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.view3d.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View3dBindedComponent.prototype, "hidden", {
        get: /**
         * @return {?}
         */
        function () {
            return !this.tk3d.tk3dStatus.view3d.visible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View3dBindedComponent.prototype, "showLoader", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.view3d.showLoader;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View3dBindedComponent.prototype, "resetModules", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.resetModules;
        },
        enumerable: true,
        configurable: true
    });
    View3dBindedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-view3d-binded',
                    template: "<tk3d-view3d [panoID]=\"panoSelected\" [size]=\"size\" [hidden]=\"hidden\" [showLoader]=\"showLoader\"\n             [reset]=\"resetModules\"></tk3d-view3d>\n"
                }] }
    ];
    /** @nocollapse */
    View3dBindedComponent.ctorParameters = function () { return [
        { type: Tk3dService },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return View3dBindedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockmapSeatmapComponent = /** @class */ (function () {
    function BlockmapSeatmapComponent() {
    }
    BlockmapSeatmapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-blockmap-seatmap',
                    template: "<tk3d-blockmap-binded></tk3d-blockmap-binded>\n<ng-content select=\"*.tk3d-bs-middle\"></ng-content>\n<tk3d-seatmap-binded></tk3d-seatmap-binded>\n\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BlockmapSeatmapComponent.ctorParameters = function () { return []; };
    return BlockmapSeatmapComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
Handler = /** @class */ (function () {
    function Handler() {
        this.handling = {
            blockmap: [],
            seatmap: [],
            view3d: [],
        };
    }
    /**
     * @param {?} message
     * @return {?}
     */
    Handler.prototype.canHandle = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        return this.handling[message.type].indexOf(message.event) !== -1;
    };
    return Handler;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockSelectedHandler = /** @class */ (function (_super) {
    __extends(BlockSelectedHandler, _super);
    function BlockSelectedHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['elementselected'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    BlockSelectedHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        status.blockmap.selected = message.element.id;
        status.blockmap.size = 'mini';
        status.seatmap.visible = true;
        status.seatmap.size = 'large';
        // status.seatmap.moduleRef['show']();
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    BlockSelectedHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BlockSelectedHandler.ctorParameters = function () { return []; };
    return BlockSelectedHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockClickHandler = /** @class */ (function (_super) {
    __extends(BlockClickHandler, _super);
    function BlockClickHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['click'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    BlockClickHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize !== 'large' || status.blockmap.size === 'mini') {
            return;
        }
        status.blockmap.moduleRef['unselectAll']();
        status.blockmap.moduleRef['select'](message.element.id);
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    BlockClickHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BlockClickHandler.ctorParameters = function () { return []; };
    return BlockClickHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockmapMiniClickHandler = /** @class */ (function (_super) {
    __extends(BlockmapMiniClickHandler, _super);
    function BlockmapMiniClickHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['click'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    BlockmapMiniClickHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize !== 'mini') {
            return;
        }
        status.blockmap.size = 'large';
        status.seatmap.visible = false;
        status.blockmap.selected = undefined;
        // status.view3d.visible = false;
        // status.seatmap.moduleRef['hide']();
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    BlockmapMiniClickHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BlockmapMiniClickHandler.ctorParameters = function () { return []; };
    return BlockmapMiniClickHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TK3dResizeHelper = /** @class */ (function () {
    function TK3dResizeHelper(config) {
        this.config = config;
        if (!this.config.resizeWrappers) {
            console.error('Service should be initialized with the wrappers ids');
        }
        this.mapWrapper = this.config.resizeWrappers.mapWrapper;
        this.seatWrapper = this.config.resizeWrappers.seatWrapper.seats;
        this.extra = this.config.resizeWrappers.seatWrapper.extra || [];
    }
    /**
     * @param {?=} force
     * @return {?}
     */
    TK3dResizeHelper.prototype.setMaxHeight = /**
     * @param {?=} force
     * @return {?}
     */
    function (force) {
        if (force === void 0) { force = false; }
        var e_1, _a;
        /** @type {?} */
        var neww = window.innerWidth;
        /** @type {?} */
        var newh = window.innerHeight;
        if (this.oldw !== neww || this.oldh !== newh || force === true) {
            this.oldw = neww;
            this.oldh = newh;
            /** @type {?} */
            var h = document.getElementById(this.mapWrapper).offsetHeight;
            try {
                for (var _b = __values(this.extra), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var extra = _c.value;
                    h -= document.getElementById(extra).offsetHeight;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            document.getElementById(this.seatWrapper).style.height = h + "px";
        }
        requestAnimationFrame(this.setMaxHeight.bind(this));
    };
    TK3dResizeHelper.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TK3dResizeHelper.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return TK3dResizeHelper;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BlockmapLoadHandler = /** @class */ (function (_super) {
    __extends(BlockmapLoadHandler, _super);
    function BlockmapLoadHandler(availability, aux, config, injector) {
        var _this = _super.call(this) || this;
        _this.availability = availability;
        _this.aux = aux;
        _this.config = config;
        _this.injector = injector;
        _this.handling['blockmap'] = ['loaded'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    BlockmapLoadHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        var _this = this;
        if (this.config.hasOwnProperty('resizeWrappers')) {
            this.aux.setMaxHeight(true);
        }
        /** @type {?} */
        var removeUnavailable = this.config.removeUnavailable !== undefined && this.config.removeUnavailable['blockmap'] !== undefined ?
            this.config.removeUnavailable['blockmap'] : true;
        this.availability.getGeneralAvailability()
            .subscribe(function (data) {
            status.blockmap.moduleRef['setAvailability'](data, removeUnavailable);
            /** @type {?} */
            var tk3d = _this.injector.get(Tk3dService);
            tk3d.onMapAvailabilityLoaded('blockmap');
        });
    };
    BlockmapLoadHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BlockmapLoadHandler.ctorParameters = function () { return [
        { type: AvailabilityService },
        { type: TK3dResizeHelper, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] },
        { type: Injector }
    ]; };
    return BlockmapLoadHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatmapLoadHandler = /** @class */ (function (_super) {
    __extends(SeatmapLoadHandler, _super);
    function SeatmapLoadHandler(availability, config, injector) {
        var _this = _super.call(this) || this;
        _this.availability = availability;
        _this.config = config;
        _this.injector = injector;
        _this.handling['seatmap'] = ['loaded'];
        return _this;
    }
    /**
     * @param {?} mapcontainer_id
     * @return {?}
     */
    SeatmapLoadHandler.prototype.getSize = /**
     * @param {?} mapcontainer_id
     * @return {?}
     */
    function (mapcontainer_id) {
        /** @type {?} */
        var bg = document.querySelectorAll('#seatmap .svg-img-background');
        /** @type {?} */
        var ar = 0;
        if (bg.length > 0) {
            ar = bg[0]['height']['baseVal']['value'] / bg[0]['width']['baseVal']['value'];
        }
        else {
            ar = 9 / 16;
        }
        return ar;
    };
    /**
     * @param {?} status
     * @return {?}
     */
    SeatmapLoadHandler.prototype.setSize = /**
     * @param {?} status
     * @return {?}
     */
    function (status) {
        /** @type {?} */
        var ar = this.getSize('seatmap');
        status.seatmap.moduleRef['setAspectRatio'](ar);
    };
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    SeatmapLoadHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        var _this = this;
        /** @type {?} */
        var removeUnavailable = this.config.removeUnavailable !== undefined && this.config.removeUnavailable['seatmap'] !== undefined ?
            this.config.removeUnavailable['seatmap'] : true;
        this.setSize(status);
        this.availability.getAreaAvailability((/** @type {?} */ (status.blockmap.selected)))
            .subscribe(function (data) {
            status.seatmap.moduleRef['setAvailability'](data, removeUnavailable);
            /** @type {?} */
            var tk3d = _this.injector.get(Tk3dService);
            tk3d.onMapAvailabilityLoaded('seatmap');
        });
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    SeatmapLoadHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeatmapLoadHandler.ctorParameters = function () { return [
        { type: AvailabilityService },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] },
        { type: Injector }
    ]; };
    return SeatmapLoadHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MapMouseEnterHandler = /** @class */ (function (_super) {
    __extends(MapMouseEnterHandler, _super);
    function MapMouseEnterHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['mouseenter'];
        _this.handling['seatmap'] = ['mouseenter'];
        _this.blockPopover =
            _this.seatPopover = document.getElementById('blockPopover');
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    MapMouseEnterHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize === 'mini') {
            return;
        }
        /** @type {?} */
        var rect = message.element.HTMLElement.getBoundingClientRect();
        /** @type {?} */
        var elementToDisplay;
        /** @type {?} */
        var sector = message.element.id.split('_')[1].split('-')[0];
        if (message.emitter === 'blockmap') {
            elementToDisplay = document.getElementById('blockPopover');
            /** @type {?} */
            var blockText = document.getElementById('blockPopoverText');
            blockText.innerText = sector;
        }
        else {
            elementToDisplay = document.getElementById('seatPopover');
            /** @type {?} */
            var row = message.element.id.split('_')[1].split('-')[1];
            /** @type {?} */
            var seat = message.element.id.split('_')[1].split('-')[2];
            document.getElementById('seatPopoverRow').innerText = row;
            document.getElementById('seatPopoverSeat').innerText = seat;
            document.getElementById('seatPopoverSector').innerText = sector;
        }
        elementToDisplay.style.left = (rect.left + 40) + "px";
        elementToDisplay.style.top = rect.top - 20 + "px";
        elementToDisplay.style.display = 'block';
    };
    MapMouseEnterHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapMouseEnterHandler.ctorParameters = function () { return []; };
    return MapMouseEnterHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MapMouseLeaveHandler = /** @class */ (function (_super) {
    __extends(MapMouseLeaveHandler, _super);
    function MapMouseLeaveHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['mouseleave'];
        _this.handling['seatmap'] = ['mouseleave'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    MapMouseLeaveHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize === 'mini') {
            return;
        }
        /** @type {?} */
        var elementToHide = message.emitter === 'blockmap' ?
            document.getElementById('blockPopover') : document.getElementById('seatPopover');
        elementToHide.style.display = 'none';
    };
    MapMouseLeaveHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MapMouseLeaveHandler.ctorParameters = function () { return []; };
    return MapMouseLeaveHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatmapClickHandler = /** @class */ (function (_super) {
    __extends(SeatmapClickHandler, _super);
    function SeatmapClickHandler() {
        var _this = _super.call(this) || this;
        _this.handling['seatmap'] = ['click'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    SeatmapClickHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize !== 'large') {
            return;
        }
        /** @type {?} */
        var seatStatus = status.seatmap.moduleRef['getElementById'](message.element.id)['status'];
        /** @type {?} */
        var maximum = status.seatmap.moduleRef['getMaxSelectables']();
        if (seatStatus.indexOf('selected') !== -1) { // if selected we unselect
            status.seatmap.moduleRef['unselect'](message.element.id);
        }
        else if (seatStatus.indexOf('available') !== -1) { // if not available do nothing
            if (status.seatmap.moduleRef['getSelected']().length === maximum && maximum === 1) { // if maximum, unselect the first
                status.seatmap.moduleRef['unselect'](status.seatmap.selected[0]);
            }
            status.seatmap.moduleRef['select'](message.element.id); // finally select the element
        }
    };
    SeatmapClickHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeatmapClickHandler.ctorParameters = function () { return []; };
    return SeatmapClickHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatmapMiniClickHandler = /** @class */ (function (_super) {
    __extends(SeatmapMiniClickHandler, _super);
    function SeatmapMiniClickHandler() {
        var _this = _super.call(this) || this;
        _this.handling['seatmap'] = ['click'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    SeatmapMiniClickHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        if (message.emmitterSize !== 'mini') {
            return;
        }
        status.seatmap.size = 'large';
        // status.blockmap.visible = false;
        // status.view3d.visible = false;
        // status.seatmap.selected = undefined;
        // status.seatmap.moduleRef['hide']();
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    SeatmapMiniClickHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeatmapMiniClickHandler.ctorParameters = function () { return []; };
    return SeatmapMiniClickHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatSelectedHandler = /** @class */ (function (_super) {
    __extends(SeatSelectedHandler, _super);
    function SeatSelectedHandler() {
        var _this = _super.call(this) || this;
        _this.handling['seatmap'] = ['elementselected'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    SeatSelectedHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        /** @type {?} */
        var maximum = status.seatmap.moduleRef['getMaxSelectables']();
        /** @type {?} */
        var selected = (/** @type {?} */ (status.seatmap.selected));
        selected.push(message.element.id);
        /*if (selected.length > maximum ) {
          selected.shift();
        }*/
        // status.seatmap.moduleRef['show']();
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    SeatSelectedHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeatSelectedHandler.ctorParameters = function () { return []; };
    return SeatSelectedHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SeatUnselectedHandler = /** @class */ (function (_super) {
    __extends(SeatUnselectedHandler, _super);
    function SeatUnselectedHandler() {
        var _this = _super.call(this) || this;
        _this.handling['seatmap'] = ['elementunselected'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    SeatUnselectedHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        /** @type {?} */
        var seat = message.element.id;
        /** @type {?} */
        var index = status.seatmap.selected.indexOf(seat);
        if (index !== -1) {
            ((/** @type {?} */ (status.seatmap.selected))).splice(index, 1);
        }
    };
    SeatUnselectedHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeatUnselectedHandler.ctorParameters = function () { return []; };
    return SeatUnselectedHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var V3dBlockSelectedHandler = /** @class */ (function (_super) {
    __extends(V3dBlockSelectedHandler, _super);
    function V3dBlockSelectedHandler() {
        var _this = _super.call(this) || this;
        _this.handling['blockmap'] = ['elementselected'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    V3dBlockSelectedHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        status.view3d.visible = true;
        status.view3d.selected = message.element.id;
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    V3dBlockSelectedHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    V3dBlockSelectedHandler.ctorParameters = function () { return []; };
    return V3dBlockSelectedHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var V3dSeatSelectedHandler = /** @class */ (function (_super) {
    __extends(V3dSeatSelectedHandler, _super);
    function V3dSeatSelectedHandler() {
        var _this = _super.call(this) || this;
        _this.handling['seatmap'] = ['elementselected'];
        return _this;
    }
    /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    V3dSeatSelectedHandler.prototype.handle = /**
     * @param {?} message
     * @param {?} status
     * @return {?}
     */
    function (message, status) {
        status.view3d.visible = true;
        status.view3d.selected = message.element.id;
        // status.blockmap.moduleRef['setContainer']('blockmap-mini');
    };
    V3dSeatSelectedHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    V3dSeatSelectedHandler.ctorParameters = function () { return []; };
    return V3dSeatSelectedHandler;
}(Handler));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Tk3drelocationComponent = /** @class */ (function () {
    function Tk3drelocationComponent(tk3d) {
        this.tk3d = tk3d;
    }
    /**
     * @return {?}
     */
    Tk3drelocationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    Object.defineProperty(Tk3drelocationComponent.prototype, "blockSelected", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tk3d.tk3dStatus.blockmap.selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} message
     * @return {?}
     */
    Tk3drelocationComponent.prototype.generalHandle = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.tk3d.handle(message);
    };
    Tk3drelocationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-relocation',
                    template: "<!-- generic template for tk3d relocation -->\n",
                    providers: [Tk3dService,
                        { provide: TK3D_HANDLERS, multi: true, useClass: BlockSelectedHandler }],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    Tk3drelocationComponent.ctorParameters = function () { return [
        { type: Tk3dService }
    ]; };
    return Tk3drelocationComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MapMiniComponent = /** @class */ (function () {
    // @Output() tk3dclick = new EventEmitter<InteractionMessageProtocol>();
    function MapMiniComponent(tk3d) {
        this.tk3d = tk3d;
    }
    /**
     * @return {?}
     */
    MapMiniComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    MapMiniComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var message = {
            event: 'click',
            emmitterSize: 'mini',
            emitter: this.type,
        };
        this.tk3d.handle(message);
    };
    MapMiniComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tk3d-map-mini',
                    template: "<div id={{type}}-mini (click)=\"onClick()\"></div>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    MapMiniComponent.ctorParameters = function () { return [
        { type: Tk3dService }
    ]; };
    MapMiniComponent.propDecorators = {
        type: [{ type: Input }]
    };
    return MapMiniComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Tk3dFileConfiguratorService = /** @class */ (function () {
    function Tk3dFileConfiguratorService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    Tk3dFileConfiguratorService.prototype.configureFromFile = /**
     * @param {?} callback
     * @return {?}
     */
    function (callback) {
        var _this = this;
        return this.http.get(this.config.onlineConfiguration.filePath).pipe(tap(function (data) {
            callback(_this.config, data);
        })).toPromise();
    };
    Tk3dFileConfiguratorService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    Tk3dFileConfiguratorService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: [TK3D_CONFIG,] }] }
    ]; };
    return Tk3dFileConfiguratorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Tk3dModule = /** @class */ (function () {
    function Tk3dModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    Tk3dModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var providers = [
            // AllMapEventsArrayHelperProvider,
            // AllView3dEventsArrayHelperProvider,
            { provide: TK3D_CONFIG, useValue: config }
        ];
        /** @type {?} */
        var basicHandlers = [
            { provide: TK3D_HANDLERS, multi: true, useClass: BlockmapLoadHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: BlockClickHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: BlockSelectedHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: SeatmapLoadHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: SeatmapClickHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: SeatSelectedHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: SeatUnselectedHandler },
            // {provide: TK3D_HANDLERS, multi: true, useClass: MapMouseEnterHandler},
            // {provide: TK3D_HANDLERS, multi: true, useClass: MapMouseLeaveHandler},
            { provide: TK3D_HANDLERS, multi: true, useClass: BlockmapMiniClickHandler },
            { provide: TK3D_HANDLERS, multi: true, useClass: SeatmapMiniClickHandler },
        ];
        /** @type {?} */
        var finalProviders = providers;
        if (config.basicConfig) {
            finalProviders = providers.concat(basicHandlers);
            /** @type {?} */
            var availabilityProvider = { provide: AvailabilityService, useClass: config.basicConfig.availabilityServiceClass };
            finalProviders.push(availabilityProvider);
        }
        if (config.resizeWrappers) {
            finalProviders.push(TK3dResizeHelper);
        }
        if (config.injectTk3dService) {
            finalProviders.push(Tk3dService);
        }
        if (config.onlineConfiguration) {
            finalProviders.push(Tk3dFileConfiguratorService);
            finalProviders.push({ provide: APP_INITIALIZER, useFactory: function (configService) {
                    return function () { return configService.configureFromFile(config.onlineConfiguration.function); };
                }, deps: [Tk3dFileConfiguratorService], multi: true });
        }
        if (config.resizeService) {
            /** @type {?} */
            var resizeProvider = { provide: ResizeService, useClass: config.resizeService };
            finalProviders.push(resizeProvider);
        }
        return {
            ngModule: Tk3dModule,
            providers: finalProviders
        };
    };
    /**
     * @param {?} config
     * @return {?}
     */
    Tk3dModule.forChild = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return Tk3dModule.forRoot(config);
    };
    Tk3dModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        MapComponent,
                        Tk3drelocationComponent,
                        BlockmapSeatmapComponent,
                        View3dComponent,
                        MapMiniComponent,
                        BlockmapBindedComponent,
                        SeatmapBindedComponent,
                        View3dBindedComponent,
                    ],
                    exports: [
                        MapComponent,
                        View3dComponent,
                        Tk3drelocationComponent,
                        BlockmapSeatmapComponent,
                        MapMiniComponent,
                        BlockmapBindedComponent,
                        SeatmapBindedComponent,
                        View3dBindedComponent,
                    ],
                    providers: [
                        AllMapEventsArrayHelperProvider,
                        AllView3dEventsArrayHelperProvider,
                    ]
                },] }
    ];
    return Tk3dModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { Tk3dModule, Tk3dService, TK3dResizeHelper, MapComponent, Tk3dMapService, AllMapEventsArrayHelperProvider, View3dComponent, View3dService, AllView3dEventsArrayHelperProvider, BlockmapBindedComponent, SeatmapBindedComponent, View3dBindedComponent, BlockmapSeatmapComponent, Tk3drelocationComponent, AvailabilityService, ResizeService, Handler, TK3D_HANDLERS, BlockSelectedHandler, BlockClickHandler, BlockmapMiniClickHandler, BlockmapLoadHandler, SeatmapLoadHandler, MapMouseEnterHandler, MapMouseLeaveHandler, SeatmapClickHandler, SeatmapMiniClickHandler, SeatSelectedHandler, SeatUnselectedHandler, V3dBlockSelectedHandler, V3dSeatSelectedHandler, TK3D_CONFIG };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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